import React from 'react';

import { Waypoint } from 'react-waypoint';

import { Spaced, TitleSpaced } from '../common/container/Container.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { Cities } from '../common/input/DropDown.jsx';

import { Tab } from '../common/container/Container.jsx';
import { ShowVertical } from '../common/container/Cell.jsx';

class Shows extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            upcoming: {
                limit: 6,
                loading: false,
                offset: 0
            },
            past: {
                limit: 6,
                loading: false,
                offset: 0
            },
            suggested: {
                limit: 6,
                loading: false,
                offset: 0
            },
            tabs: [{ active: true, label: 'Suggested Shows', tab: 'suggested' }, { label: 'Upcoming Shows', tab: 'upcoming' }, { label: 'Past Shows', tab: 'past' }],
            tab: 'suggested',
        };

        this._get = this._get.bind(this);

        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleWaypointEnter = this.handleWaypointEnter.bind(this);
    }

    componentWillUnmount() {
        if (this.upcomingRequest) {
            this.upcomingRequest.abort();
            this.upcomingRequest = null;
        }
    }

    _get(showType) {
        const component = this;
        const state = component.state[showType];
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            [showType]: state
        });
        component.upcomingRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.shows.get(),
            {
                limit: state.limit,
                offset: state.offset,
                when: showType === 'past' ? 'Past' : 'CurrentUpcoming',
                type: showType === 'suggested' ? 'Featured' : 'Opted',
            },
            function (responseData) {
                component.upcomingRequest = null;

                responseData.Shows.forEach(function (d) {
                    if (d.Title && d.Title.length > 80) {
                        d.Title = d.Title.substring(0, 80) + '...';
                    }
                    if (d.Image) {
                        d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, 250, 200);
                    }
                });

                let data = state.data || [];
                state.data = data.concat(responseData.Shows);

                state.offset += responseData.Shows.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    [showType]: state
                });
            },
            function (jqXHR, textStatus) {
                component.upcomingRequest = null;

                state.loading = false;
                component.setState({
                    [showType]: state
                });

                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleTabClick(newTab) {
        const tabs = this.state.tabs.map(
            tab => tab.tab === newTab ?
                { ...tab, active: true } :
                { ...tab, active: false }
        );

        this.setState({
            tabs,
            tab: newTab
        });

        this._get(newTab);
    }

    handleWaypointEnter(showType) {
        if (this.state[showType].data && this.state[showType].offset >= this.state[showType].total) {
            return;
        }
        this._get(showType);
    }

    render() {
        const { tabs, tab } = this.state;
        let shows;
        if (this.state[tab].data) {
            shows = this.state[tab].data.map((d, idx) => <div key={idx} className="grid grid--6 spacer--bottom"><ShowVertical key={d.ShowId} d={d} inline={true} multiline={true} /></div>);
        }
        return (
            <React.Fragment>
                <div className="section spacer--nsb">
                    <div className="container">
                        <TitleSpaced>
                            <h2>Browse Shows</h2>
                            <div className="section__title__controls">
                                <Cities />
                            </div>
                        </TitleSpaced>
                    </div>
                </div>
                <Tab tabs={tabs} onClick={this.handleTabClick} />
                <section className="section spacer--top">
                    <Spaced>
                        <div className="container--spaced__row container--waypoint">
                            {shows}
                            <div className="loading--waypoint">
                                <Waypoint onEnter={() => this.handleWaypointEnter(tab)} />
                            </div>
                        </div>
                        {
                            this.state[tab].loading &&
                            <LoadingIndicator />
                        }
                    </Spaced>
                </section>
            </React.Fragment>
        );
    }
}

export default Shows;